// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Building2 (chain) icon with a "+" badge in the bottom-right corner.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function ChainPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M10 12h4" />
      <path d="M10 8h4" />
      <path d="M13 16.273A2 2 0 0 0 10 18v3" />
      <path d="M18 7h2a2 2 0 0 1 2 2v4" />
      <path d="M19 16v6" />
      <path d="M22 19h-6" />
      <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8.5" />
      <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v7" />
    </svg>
  );
}
